/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetCardTransactionEvidenceRecords200ResponseInnerErrors } from './get-card-transaction-evidence-records200-response-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardTransactionEvidenceRecords200ResponseInnerInvoiceIssuer } from './get-card-transaction-evidence-records200-response-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardTransactionEvidenceRecords200ResponseInnerUpdatedBy } from './get-card-transaction-evidence-records200-response-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardTransactionEvidenceRecords200ResponseInnerUploadedBy } from './get-card-transaction-evidence-records200-response-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardTransactionEvidenceRecords200ResponseInnerWarnings } from './get-card-transaction-evidence-records200-response-inner-warnings';

/**
 * 
 * @export
 * @interface GetCardTransactionEvidenceRecords200ResponseInner
 */
export interface GetCardTransactionEvidenceRecords200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'evidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'paymentType': GetCardTransactionEvidenceRecords200ResponseInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'electronicMethod': GetCardTransactionEvidenceRecords200ResponseInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'documentSize': GetCardTransactionEvidenceRecords200ResponseInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'legalValidity': GetCardTransactionEvidenceRecords200ResponseInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetCardTransactionEvidenceRecords200ResponseInnerInvoiceIssuer}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'invoiceIssuer': GetCardTransactionEvidenceRecords200ResponseInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'dpiError': GetCardTransactionEvidenceRecords200ResponseInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'detectedDpiError': GetCardTransactionEvidenceRecords200ResponseInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'calculatedDpiError': GetCardTransactionEvidenceRecords200ResponseInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'colorGradationError': GetCardTransactionEvidenceRecords200ResponseInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'heightMillisError': GetCardTransactionEvidenceRecords200ResponseInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'widthMillisError': GetCardTransactionEvidenceRecords200ResponseInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetCardTransactionEvidenceRecords200ResponseInnerErrors}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'errors': GetCardTransactionEvidenceRecords200ResponseInnerErrors;
    /**
     * 
     * @type {GetCardTransactionEvidenceRecords200ResponseInnerWarnings}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'warnings': GetCardTransactionEvidenceRecords200ResponseInnerWarnings;
    /**
     * 
     * @type {GetCardTransactionEvidenceRecords200ResponseInnerUpdatedBy}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'updatedBy': GetCardTransactionEvidenceRecords200ResponseInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetCardTransactionEvidenceRecords200ResponseInnerUploadedBy}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'uploadedBy': GetCardTransactionEvidenceRecords200ResponseInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'uploadedFrom': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'deleted': boolean;
}

export const GetCardTransactionEvidenceRecords200ResponseInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerPaymentTypeEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerPaymentTypeEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerPaymentTypeEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerElectronicMethodEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerElectronicMethodEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerElectronicMethodEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerDocumentSizeEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerDocumentSizeEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerDocumentSizeEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerLegalValidityEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerLegalValidityEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerLegalValidityEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerDpiErrorEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerDpiErrorEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerDpiErrorEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerDetectedDpiErrorEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerDetectedDpiErrorEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerDetectedDpiErrorEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerCalculatedDpiErrorEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerCalculatedDpiErrorEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerCalculatedDpiErrorEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerColorGradationErrorEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerColorGradationErrorEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerColorGradationErrorEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerHeightMillisErrorEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerHeightMillisErrorEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerHeightMillisErrorEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerWidthMillisErrorEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerWidthMillisErrorEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerWidthMillisErrorEnum];


